import React from "react";
import BotCard from "./BotCard";
import "./BotCollection.css"

function BotCollection({ bots, onBotClick, onDeleteBot }) {

    return (
        <div className="container">
            <h2>Bot Collection</h2>
            <div className="list">
                <div className="bot-grid">
                {bots.map(bot => (
                    <span key={bot.id} onClick={() => onBotClick(bot)}className="bot-wrapper">
                        <BotCard 
                            bot={bot}
                            onDeleteBot={onDeleteBot}  
                        />
                    </span>
                ))}
                </div>  
            </div>   
        </div>
    )
}

export default BotCollection;